<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />

    <!-- Container geral com a mesma aparência física de card elevado -->
    <div class="tabela-mandatos" v-if="tiposOrdenados && tiposOrdenados.length !== 0">
      <div class="tabela-mandatos__scroll">
        <table class="table">
          <colgroup>
            <col class="col-nome" />
            <col class="col-codigo" />
            <col class="col-ativo" />
          </colgroup>
          <thead>
            <tr>
              <th class="th-nome">Nome</th>
              <th class="th-codigo">Código</th>
              <th class="th-ativo">Ativo</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="tipoMandato in tiposOrdenados">
              <tr 
                :key="tipoMandato.id" 
                class="linha-clicavel" 
                @click="irParaDetalhes(tipoMandato.id)"
              >       
                <td data-label="Nome:" class="td-nome">
                  <span>{{ tipoMandato.nome }}</span>
                </td>
                <td data-label="Código:" class="td-codigo">
                  <span>{{ tipoMandato.codigo }}</span>
                </td>
                <td data-label="Ativo:" class="td-ativo">
                  <!-- Aplicação do mesmo estilo de badge de status -->
                  <span 
                    class="status-badge" 
                    :class="tipoMandato.ativo ? 'status-badge--ativo' : 'status-badge--inativo'"
                  >
                    {{ tipoMandato.ativo ? 'Sim' : 'Não' }}
                  </span>

                  <!-- Modal de exclusão mantido no DOM com click.stop -->
                  <div class="modal-exclusao" :id="'modal-exclusao-' + tipoMandato.id" @click.stop>
                    <div class="modal-mask">
                      <div class="modal-container">
                        <div class="modal-header">
                          <h2>Deseja mesmo excluir este tipo de mandato?</h2>
                        </div>
                        <div class="modal-body">
                          <p>Dados do Tipo de Mandato:</p>
                          <div class="dados">
                            <div class="texto-codigo">
                              Código: <span>{{ tipoMandato.codigo }}</span>
                            </div>
                            <div class="texto-nome">
                              Nome: <span>{{ tipoMandato.nome }}</span>
                            </div>
                            <div class="texto-ativo">
                              Ativo: <span>{{ tipoMandato.ativo ? 'Sim' : 'Não' }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button class="btn-confirmar-exclusao" @click.stop="excluirTipoMandato(tipoMandato.id)">Sim</button>
                          <button class="btn-cancelar-exclusao" @click.stop="opcoesExcluir(tipoMandato.id)">Não</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Estado vazio seguindo o padrão da outra tabela -->
    <div class="tabela-mandatos tabela-mandatos--vazia" v-else>
      <p class="sem-resultados">Nenhum mandato cadastrado</p>
    </div>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import MsgErroFormularios from "../MsgErroFormularios";
import TipoMandatoApi from "../../services/TipoMandatoApi";

export default {
  name: "TabelaResultadosTipoMandato",
  props: {
    tiposMandato: Array,
  },
  components: {
    MsgErroFormularios,
  },
  data() {
    return {
      msgErros: {
        tipoMandato: "",
      },
      erro: false,
      tipoMandatoApi: null,
    };
  },
  created() {
    this.tipoMandatoApi = new TipoMandatoApi();
  },
  computed: {
    tiposOrdenados() {
      if (!this.tiposMandato) return [];
      // Ordena os tipos de mandato pelo código
      return this.tiposMandato.slice().sort((a, b) => a.codigo - b.codigo);
    }
  },
  methods: {
    irParaDetalhes(id) {
      this.$router.push({ name: 'TipoMandatoShow', params: { id: id } });
    },
    opcoesExcluir(tipoMandatoId) {
      const modalExclusao = document.getElementById(`modal-exclusao-${tipoMandatoId}`);
      if (modalExclusao) {
        modalExclusao.classList.toggle("visible");
      }
    },
    async excluirTipoMandato(tipoMandatoId) {
      try {
        await this.tipoMandatoApi.destroyTipoMandato(tipoMandatoId);
        window.location.reload(); // Recarrega a página após a exclusão
      } catch (err) {
        console.error("Erro ao excluir tipo de mandato:", err);
        this.erro = true;
        this.msgErros.tipoMandato = "Não foi possível excluir este tipo de mandato.";
      }
    },
    fecharErro() {
      this.erro = false;
    },
    formatarData: function (value) {
      if (value == null) {
        return;
      }
      return format(parseISO(value), "dd/MM/yyyy");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/TabelaResultadosBase.scss";

/* -------------------------------------------------------------------------- */
/* Tabela de mandatos — Identidade visual SITRA                               */
/* -------------------------------------------------------------------------- */
.tabela-mandatos {
  margin-top: 1.35rem;
  background: #ffffff;
  border: 1px solid #dde5e0;
  border-radius: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 10px 28px rgba(0, 0, 0, 0.08);
  overflow: visible;
}

.tabela-mandatos--vazia {
  padding: 1.75rem 1rem;
  text-align: center;
  overflow: hidden;
  
  .sem-resultados {
    margin: 0;
    color: #5f6f66;
    font-family: "Karla", sans-serif;
    font-size: 0.9rem;
  }
}

.tabela-mandatos__scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  border-radius: 0.85rem;
}

.tabela-mandatos .table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0;
  table-layout: fixed;
}

/* Definição de larguras para as 3 colunas */
.tabela-mandatos .col-nome { width: 50%; }
.tabela-mandatos .col-codigo { width: 25%; }
.tabela-mandatos .col-ativo { width: 25%; }

/* Estilos de Célula e Cabeçalho */
.tabela-mandatos .table th,
.tabela-mandatos .table td {
  border: none !important;
  border-bottom: 1px solid #e7eee9 !important;
  padding: 0.75rem 0.85rem;
  vertical-align: middle;
  font-size: 0.95rem;
  color: #1f2d24;
  font-family: "Karla", sans-serif;
  background: transparent;
  border-radius: 0 !important;
}

/* Alinhamentos específicos */
.tabela-mandatos .table .th-nome,
.tabela-mandatos .table .td-nome {
  text-align: left;
}

.tabela-mandatos .table .th-codigo,
.tabela-mandatos .table .td-codigo,
.tabela-mandatos .table .th-ativo,
.tabela-mandatos .table .td-ativo {
  text-align: center;
}

/* Estilização do cabeçalho */
.tabela-mandatos .table thead th {
  background: #ededed !important;
  color: #005516 !important;
  font-family: "Karla", sans-serif;
  font-size: 0.95rem;
  font-weight: 700; /* Substitui o Montserrat-Bold */
  letter-spacing: 0.01em;
  line-height: 1.25;
  border-bottom: 1px solid #d5e2d9 !important;
  border-right: 1px solid #a6c9b1 !important;
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
}

/* Efeito Zebrado nas Linhas */
.tabela-mandatos .table tbody tr {
  transition: background-color 0.15s ease;
  background-color: #ffffff; // Garante que a primeira linha (e as ímpares) fiquem brancas
}

// Altera a segunda, quarta, sexta e todas as linhas pares para a cor #ededed
.tabela-mandatos .table tbody tr:nth-child(even) {
  background-color: #ededed !important;
}

/* Linha Clicável & Hover com a paleta Verde Institucional */
.linha-clicavel {
  cursor: pointer;
}

.tabela-mandatos .table tbody tr.linha-clicavel:hover {
  background: rgba(0, 85, 22, 0.05) !important;
}

/* Destaque para o campo Código */
.tabela-mandatos .td-codigo {
  font-family: "Karla", sans-serif;
  color: #005516;
  font-weight: 700; /* Substitui o Montserrat-Bold */
}

/* -------------------------------------------------------------------------- */
/* Badges de Status (Sim/Não)                                                 */
/* -------------------------------------------------------------------------- */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-family: "Karla", sans-serif;
  font-weight: 700; /* Substitui o Montserrat-Bold */
  line-height: 1.25;
  text-align: center;
}

.status-badge--ativo {
  background: rgba(0, 85, 22, 0.12);
  color: #005516;
}

.status-badge--inativo {
  background: rgba(180, 40, 40, 0.1);
  color: #9b2c2c;
}

/* -------------------------------------------------------------------------- */
/* Modal de Exclusão (Mantido e ajustado para não conflitar com o design)     */
/* -------------------------------------------------------------------------- */
.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: none; /* É ativado pela classe .visible via JS */
  transition: opacity 0.3s ease;
  
  &.visible {
    display: table !important;
  }

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1001;
    top: 20vh;
    width: calc(40vw - 5rem);
    height: fit-content;
    background-color: #f2f2f2;
    margin: 0 auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }

  .modal-container {
    padding: 1.2rem;
    font-family: "Karla", sans-serif;
    
    .modal-header h2 {
      font-size: 1.2rem;
      font-family: "Karla", sans-serif;
      font-weight: 700;
      color: #1f2d24;
      margin-bottom: 1rem;
    }

    .modal-body {
      border: 1px solid #dde5e0;
      border-radius: 0.75rem;
      background: #ffffff;
      padding: 1rem;
      text-align: left;
      
      p {
        font-family: "Karla", sans-serif;
        font-weight: 700;
        font-size: 0.95rem;
        margin-bottom: 0.75rem;
        color: #005516;
      }

      .dados {
        font-size: 0.9rem;
        line-height: 1.5;
        
        div {
          margin-bottom: 0.25rem;
          font-family: "Karla", sans-serif;
          font-weight: 700;
          
          span {
            font-family: "Karla", sans-serif;
            font-weight: normal;
            color: #4a5a50;
            margin-left: 0.25rem;
          }
        }
      }
    }
  }

  .modal-footer {
    margin-top: 1rem;
    display: flex;
    justify-content: space-evenly;
    
    button {
      border: none;
      border-radius: 2rem;
      width: 35%;
      height: 2.2rem;
      font-family: "Karla", sans-serif;
      font-weight: 700;
      font-size: 0.9rem;
      cursor: pointer;
      transition: transform 0.1s ease, filter 0.15s ease;
      
      &:hover {
        filter: brightness(0.9);
      }
      
      &:active {
        transform: scale(0.97);
      }
    }

    .btn-confirmar-exclusao {
      background-color: #005516;
      color: #f2f2f2;
    }

    .btn-cancelar-exclusao {
      background-color: #bd0000;
      color: #f2f2f2;
    }
  }
}

/* Responsividade Mobile */
@media screen and (max-width: "768px") {
  .tabela-mandatos .table {
    min-width: 600px; /* Garante que a tabela role horizontalmente de forma elegante em telas pequenas */
  }
  .modal-exclusao .modal-mask {
    width: 90% !important;
  }
}
</style>

